import React, { useState } from 'react';
import axios from 'axios';
import '../assets/css/inquiryForm.css';

const InquiryForm = () => {

    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(
                `${backendUrl}/api/quote`,
                {
                    name: formData.name,
                    email: formData.email,
                    mobile: formData.phone,                 // ✅ FIX
                    product: "General Inquiry",              // ✅ FIX
                    application: formData.subject || "Inquiry Form",
                    message: formData.message,
                    countryCode: "+91"
                },
                { timeout: 15000 }
            );

            setShowSuccessModal(true);

            setTimeout(() => {
                setShowSuccessModal(false);
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            }, 2000);

        } catch (error) {
            console.error(error);
            alert("Failed to submit inquiry");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="inquiry-section">

            {/* ✅ SUCCESS MODAL */}
            {showSuccessModal && (
                <div className="quote-success-overlay">
                    <div className="quote-success-modal">
                        <h3>✅ Inquiry Submitted Successfully</h3>
                        <p>We’ll get back to you shortly.</p>
                    </div>
                </div>
            )}

            <div className="inquiry-container">

                {/* Left Side: Form */}
                <div className="form-card">
                    <div className="form-header">
                        <span className="form-subtitle">CONTACT FORM</span>
                        <h2>Contact us Today for Any Questions</h2>
                    </div>

                    <form onSubmit={handleSubmit} className="contact-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Your name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Subject</label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="form-group full-width">
                            <label>How we can help you?</label>
                            <textarea
                                name="message"
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                            />
                        </div>

                        <button className="primary-btn submit-btn" style={{ padding: '15px 25px', width: 'fit-content', backgroundColor:'#fff',color:'#0f766e' }}>
                            <span className="btn-text-wrap">
                                <span className="btn-text">{loading ? "Submitting..." : "Send Inquiry"}</span>
                                <span className="btn-text btn-text-abs">{loading ? "Submitting..." : "Send Inquiry"}</span>
                            </span>
                        </button>
                    </form>
                </div>

                {/* Right Side: Image */}
                {/* <div className="image-card">
                    <img
                        src={require('../assets/images/contact/WhatsApp Image 2026-01-22 at 12.09.24 PM.jpeg')}
                        alt="Laboratory professional working"
                    />
                </div> */}

            </div>
        </section>
    );
};

export default InquiryForm;